// 의견함(`0087` feedback) — 멤버가 보내고 운영자가 콘솔에서 상태·메모로 관리한다.

export const FEEDBACK_STATUSES = ["new", "review", "doing", "done", "hold"] as const;
export type FeedbackStatus = (typeof FEEDBACK_STATUSES)[number];
export const FEEDBACK_STATUS_LABEL: Record<FeedbackStatus, string> = {
  new: "새로",
  review: "검토 중",
  doing: "진행 중",
  done: "반영",
  hold: "보류",
};

// `0087` feedback_body_len · feedback_page_len · feedback_memo_len 과 같은 값.
export const FEEDBACK_BODY_MAX = 2000;
export const FEEDBACK_PAGE_MAX = 200;
export const FEEDBACK_MEMO_MAX = 1000;

export interface FeedbackRow {
  id: string;
  org_id: string;
  // 보낸 멤버 — 멤버가 지워지면 null.
  member_id: string | null;
  body: string;
  page: string | null;
  status: FeedbackStatus;
  memo: string | null;
  status_changed_at: string | null;
  created_at: string;
  updated_at: string;
}

// 멤버가 쓰는 다섯 열(열 단위 insert 권한) — 상태·메모는 기본값.
export type FeedbackInsert = Pick<FeedbackRow, "id" | "org_id" | "member_id" | "body" | "page">;

// 운영자 처리의 전/후 — 상태·메모·상태가 바뀐 시각.
export interface FeedbackAuditValues {
  status: FeedbackStatus;
  memo: string | null;
  status_changed_at: string | null;
}
